import React, { useEffect, useImperativeHandle, useState } from 'react'
import styled from 'styled-components';
import useAsyncEffect from 'use-async-effect';
import { useDispatch } from 'react-redux';
import 'react-quill/dist/quill.snow.css';
import { loading } from '../../../actions/Loading';
import api from '../../../api/api';
import { GetCampaignsResult } from '../../../model/GetCampaignsResult';
import NewCampaignComponent from '../../campaign/NewCampaignComponent';
import CampaignsTable from '../../campaign/CampaignsTable';


interface IProps {
    stockId: string;
}

const Style = styled.div`
margin: 1rem 0;



`;


export interface ICampaignPageMethods {
    save: () => Promise<boolean>
    isDirty: () => boolean
}


const CampaignPage = React.forwardRef<any, IProps>((props: IProps, ref) => {

    const dispatch = useDispatch();
    const [campaignResult, setCampaignResult] = useState<GetCampaignsResult>();
    // The open editor is tracked in the URL (?campaign=<id>) so opening it pushes a
    // history entry and the browser Back button closes it (returning to the list)
    // rather than navigating away from the page entirely.
    const [editingCampaignId, setEditingCampaignId] = useState<string>(
        () => new URLSearchParams(window.location.search).get('campaign') || ''
    );
    const newCampaignComponent = React.createRef<ICampaignPageMethods>();


    const refresh = async ()=>{
        dispatch(loading(true));
        const result = await api().getCampaigns(props.stockId);
        setCampaignResult(result);
        dispatch(loading(false));
    }

    // Refresh the list on mount and whenever the editor closes.
    useAsyncEffect(async (isMounted: () => boolean) => {

        if(!editingCampaignId){
            await refresh();
        }

    }, [ editingCampaignId ]);

    // Keep the editor in sync when the user navigates history (e.g. Back/Forward).
    useEffect(() => {
        const onPopState = () => {
            setEditingCampaignId(new URLSearchParams(window.location.search).get('campaign') || '');
        };
        window.addEventListener('popstate', onPopState);
        return () => window.removeEventListener('popstate', onPopState);
    }, []);

    const openEditor = (id:string) => {
        setEditingCampaignId(id);
        const params = new URLSearchParams(window.location.search);
        params.set('campaign', id);
        window.history.pushState({}, document.title, `${window.location.pathname}?${params.toString()}`);
    }

    const closeEditor = () => {
        setEditingCampaignId('');
        const params = new URLSearchParams(window.location.search);
        params.delete('campaign');
        const search = params.toString();
        window.history.replaceState({}, document.title, window.location.pathname + (search ? `?${search}` : ''));
    }




    useImperativeHandle(ref, (): ICampaignPageMethods => ({

        async save() {

            if(editingCampaignId){
                return newCampaignComponent.current!.save();
            }
            return true;
        },

        // Only the open campaign editor holds unsaved state.
        isDirty() {
            return !!editingCampaignId && newCampaignComponent.current ? newCampaignComponent.current.isDirty() : false;
        }

    }));

    return <Style>
        {
            !editingCampaignId && <div className="space-between">
            <h2>Campaigns</h2>
            <button onClick={()=>openEditor('new')}>Start New Campaign</button>
        </div>
        }
        {
            !!editingCampaignId && <NewCampaignComponent ref={newCampaignComponent} stockId={props.stockId} onClose={closeEditor} campaignId={editingCampaignId}/>
        }


        {
            !editingCampaignId && campaignResult && <CampaignsTable campaignResult={campaignResult} onEditCampaign={openEditor}/>

        }
    </Style>
});

export default CampaignPage;